<template>
  <div class="policyDetails_wrapper">
    <div class="insurance_info">
      <van-cell-group>
        <van-cell
          class="my_cell"
          title="保单信息"
          value="待生效"
          title-class="product_title"
          title-style="font-weight:bold"
          value-class="title_state"
          size="large"
        />
        <!-- 产品信息 -->
        <van-cell
          title="产品名称"
          :value="policyDetail.productName"
          title-class="details"
          value-class="details_state"
          class="header"
          size="large"
        />
        <van-cell
          title="保单号码"
          :value="policyDetail.policyNo"
          title-class="details"
          value-class="details_state"
          class="header"
          size="large"
        />

        <van-cell
          title="起保时间"
          :value="policyDetail.createTimeStr"
          title-class="details"
          value-class="details_state"
          class="header"
          size="large"
        />

        <van-cell
          title="产品保费"
          :value="`${policyDetail.lfee}元`"
          title-class="details"
          value-class="details_state"
          class="header"
          size="large"
        />

        <van-cell
          title="保障计划"
          :value="policyDetail.planCode"
          title-class="details"
          value-class="details_state"
          class="header"
          size="large"
        />

        <!-- 投保人信息 -->
        <van-cell value="投保人信息" class="title_second" size="large" />
        <van-cell
          title="姓名"
          :value="policyDetail.policyInsureCustomer"
          title-class="details"
          value-class="details_state"
          class="header"
          size="large"
        />
        <van-cell
          title="证件类型"
          value="身份证"
          title-class="details"
          value-class="details_state"
          class="header"
          size="large"
        />
        <van-cell
          title="证件号码"
          :value="policyDetail.insureCustomerIdNumber"
          title-class="details"
          value-class="details_state"
          class="header"
          size="large"
        />
        <van-cell
          title="手机号码"
          :value="policyDetail.mobile"
          title-class="details"
          value-class="details_state"
          class="header"
          size="large"
        />
        <!-- 被保人信息 -->
        <van-cell value="被保人信息" class="title_second" size="large" />
        <div v-for="(item, index) in coverCustomers" :key="index">
          <van-cell
            :value="`被保人${formatNumber(index)}`"
            class="applicant"
            size="large"
          />
          <van-cell
            title="姓名"
            :value="item.name"
            title-class="details"
            value-class="details_state"
            class="header"
            size="large"
          />
          <van-cell
            title="证件类型"
            value="身份证"
            title-class="details"
            value-class="details_state"
            class="header"
            size="large"
          />
          <van-cell
            title="证件号码"
            :value="item.idnumber"
            title-class="details"
            value-class="details_state"
            class="header"
            size="large"
          />
          <van-cell
            title="手机号码"
            :value="item.mobile"
            title-class="details"
            value-class="details_state"
            class="header"
            size="large"
          />
        </div>
      </van-cell-group>
    </div>
    <footer>
      <div class="ipt" @click="cancelInsuranceDialog">撤保</div>
      <div class="ipt">修改</div>
      <div class="ipt">下载保单</div>
      <div class="ipt">电子发票</div>
    </footer>
  </div>
</template>

<script>
import './PolicyDetails.less'
import { Cell, CellGroup, Dialog } from 'vant'
import { getPolicyDetailData } from '../../api/api'
import { undoPolicy } from '../../api/api'
import Nzh from 'nzh'

export default {
  name: 'PolicyDetails',
  data() {
    return {
      // 客服电话
      tel: '400-099-6778',
      // 保单详情信息
      policyDetail: {},
      //被保人集合
      coverCustomers: [],
    }
  },
  components: {
    'van-cell-group': CellGroup,
    'van-cell': Cell,
  },
  computed: {
    // 将1,2,3...返回为一,二,三....
    formatNumber() {
      return index => {
        //使用简体中文,另外有 Nzh.hk -- 繁体中文
        let nzhcn = Nzh.cn
        //转中文小写 >> 十万零一百一十一
        return nzhcn.encodeS(index + 1)
      }
    }
  },
  methods: {
    async getPolicyDetail() {
      const { appPolicy } = await getPolicyDetailData({
        appNo: '20180706044909781-1074747',
      })
      // console.log(this.policyDetail);
      this.policyDetail = appPolicy
      const { coverCustomers } = this.policyDetail
      this.coverCustomers = coverCustomers
    }
    ,
    // 撤保确认弹出框
    cancelInsuranceDialog() {
      let info = {
        appNo: '20180706044909781-1074747',
        channelName: '斑马'
      }
      Dialog.confirm({
        title: '提示',
        message: '确认要撤保吗?',
        confirmButtonColor: '#28cc77'
      }).then(() => {
        this.cancelInsurance(info)
      }).catch(err => {
        console.log(err)
      })
    }
    ,
    // 撤保
    async cancelInsurance(info) {
      try {
        await undoPolicy(info)
        Dialog.alert({
          title: '提示',
          message: '撤保成功',
          confirmButtonColor: '#28cc77'
        })
      } catch (error) {
        Dialog.confirm({
          title: '提示',
          message: `该保单已经生效，\n请联系客服热线${this.tel}进行退保`,
          confirmButtonText: '拨打',
          cancelButtonText: '知道啦',
          confirmButtonColor: '#28cc77'
        }).then(() => {
          // 拨打电话
          window.location.href = `tel:${this.tel}`
        }).catch(err => {
          console.log(err)
        })
      }

      // const { code, success } = data
      // if (code === 200) {
      //   if (!success) {
      //     Dialog.confirm({
      //       title: '提示',
      //       message: `该保单已经生效，\n请联系客服热线${this.tel}进行退保`,
      //       confirmButtonText: '拨打',
      //       cancelButtonText: '知道啦'
      //     }).then(() => {
      //       // 拨打电话
      //       window.location.href = `tel:${this.tel}`
      //     }).catch(err => {
      //       console.log(err)
      //     })
      //   } else {
      //     await Dialog.alert({
      //       title: '提示',
      //       message: '撤保成功',
      //       confirmButtonColor: '#28cc77'
      //     })
      //   }
      // }
    }
  }
  ,
  created() {
    this.getPolicyDetail()
  }
  ,
  mounted() {
    // const {
    //     productName, //产品名称
    //     policyNo, //保单号码
    //     createTimeStr, // 起保时间
    //     endTimeStr, // 起保时间
    //     lfee, // 产品保费
    //     planCode, // 保障计划
    //     policyInsureCustomer, // 投保人姓名
    //     insureCustomerIdNumber, // 投保人身份证
    //     mobile, // 投保人手机号
    //     coverCustomers, // 被保人列表
    // } = PDdata.appPolicy;
  }
  ,
}
</script>

